// axios 默认配置
import AXIOS_DEFAULT_CONFIG from './axios-defult';

// url配置 key：关键字匹配 value：url值\
// eslint-disable-next-line
export const URl_DEFAULT_CONFIG = new Map([
  [['local', '127.0.0.1'], 'http://10.200.102.167:6011'],
]);

const KEY_DEFAULT_CONFIG = new Map([
  [['localhost', '127.0.0.1', 'v6-qc-web-v6'], 'cb189396bdf29854'],
  ['v6-beta-web-v6', '26dfa299ce136334'],
  [['dairyqueen', '139.224.59.26:31026'], '30274185e983a6c6'],
]);

const getUrlInTheKey = () => {
  const { href } = window.location;
  for (const [key, value] of KEY_DEFAULT_CONFIG.entries()) {
    if (Array.isArray(key) && key.filter(val => href.indexOf(val) > -1).length) {
      return value;
    }
    if (typeof key === 'string' && href.indexOf(key) > -1) {
      return value;
    }
  }
  return '';
};

// 默认key
export const { BASEKEY, KEY } = ((function getKey() {
  const { search } = window.location;
  const defaultKey = getUrlInTheKey();
  console.log('defaultKey ===', defaultKey);
  const reg = new RegExp('(^|\\?|&)key=([^&]*)(\\s|&|$)', 'i');
  let key = '';
  if (reg.test(search)) {
    [, , key] = search.match(reg);
  }
  return {
    BASEKEY: key ? `?key=${key}` : defaultKey,
    KEY: key || defaultKey,
  };
})()); // 默认key配置

// 保留小数的位数
export const ACCURACY = 2;


// 默认餐单参数配置
export const DEFAULT_MENU_PARAMS = () => {
  const { href } = window.location;
  let id = 800005512;
  if (href.indexOf('127.0.0.1') > -1 || href.indexOf('qc') > -1) {
    id = 1010749;
  }
  return {
    menuId: id, // 门店id，默认正式环境的门店
    // sendType: 1, // 业务类型
  };
};

export {
  // eslint-disable-next-line
  AXIOS_DEFAULT_CONFIG
};
